(function() {
  function initCasasDaCostaConfigurator(root) {
    if (!root || root.dataset.cdcconfInitialized === 'true') return;

    root.dataset.cdcconfInitialized = 'true';

    var form = root.querySelector('form');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-cdc-option]'));
    var summaryOldPrice = root.querySelector('[data-summary-old-price]');
    var summaryTotal = root.querySelector('[data-summary-total]');
    var summaryCount = root.querySelector('[data-summary-count]');
    var summaryList = root.querySelector('[data-summary-list]');
    var configBody = root.querySelector('[data-config-body]');
    var emailInput = root.querySelector('[data-config-email]');
    var phoneInput = root.querySelector('[data-config-phone]');
    var emailError = root.querySelector('[data-email-error]');
    var printButton = root.querySelector('[data-print-config]');
    var pdfButton = root.querySelector('[data-pdf-config]');
    var printArea = root.querySelector('[data-print-area]');
    var settingsNode = root.querySelector('[data-cdc-config-settings]');

    var settings = {};

    try {
      settings = JSON.parse(settingsNode ? settingsNode.textContent : '{}');
    } catch (error) {
      settings = {};
    }

    settings.baseTitle = settings.baseTitle || 'Casas da Costa';
    settings.basePrice = settings.basePrice || '0';
    settings.baseOldPrice = settings.baseOldPrice || '0';
    settings.baseArticles = settings.baseArticles || 0;
    settings.emptyText = settings.emptyText || 'Sin extras seleccionados';
    settings.selectedText = settings.selectedText || 'artículos seleccionados';
    settings.currencySymbol = settings.currencySymbol || '€';
    settings.currencyPosition = settings.currencyPosition || 'after';
    settings.thousandSeparator = settings.thousandSeparator || '.';
    settings.emailRequiredMessage = settings.emailRequiredMessage || 'Introduce un correo electrónico o teléfono válido para continuar.';
    settings.contactRequiredMessage = settings.contactRequiredMessage || settings.emailRequiredMessage;
    settings.printTitle = settings.printTitle || 'Configuración Casas da Costa';

    function parseAmount(value) {
      if (value === null || value === undefined) return 0;

      var raw = String(value).trim();
      if (!raw) return 0;

      var isNegative = raw.indexOf('-') !== -1;
      var clean = raw.replace(/[^\d]/g, '');
      var number = parseInt(clean, 10);

      if (isNaN(number)) return 0;
      return isNegative ? number * -1 : number;
    }

    function formatNumber(value) {
      var separator = settings.thousandSeparator || '.';
      var number = Math.round(Math.abs(value)).toString();

      return number.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function formatMoney(value) {
      var symbol = settings.currencySymbol || '€';
      var number = formatNumber(value);

      if (settings.currencyPosition === 'after') {
        return number + ' ' + symbol;
      }

      return symbol + ' ' + number;
    }

    function formatTotalMoneyHtml(value) {
      var symbol = escapeHtml(settings.currencySymbol || '€');
      var number = escapeHtml(formatNumber(value));
      var taxText = '<span class="cdcconf__iva">+ IVA</span>';

      if (settings.currencyPosition === 'after') {
        return number + ' ' + symbol + ' ' + taxText;
      }

      return symbol + ' ' + number + ' ' + taxText;
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
    }

    function isValidPhone(phone) {
      var phoneDigits = String(phone || '').replace(/[^\d]/g, '');
      return phoneDigits.length >= 6;
    }

    function getSelectedItems() {
      return options
        .filter(function(option) {
          var checkbox = option.querySelector('.cdcconf__checkbox');
          return checkbox && checkbox.checked;
        })
        .map(function(option) {
          return {
            title: option.getAttribute('data-title') || '',
            description: option.getAttribute('data-description') || '',
            price: parseAmount(option.getAttribute('data-price')),
            oldPrice: parseAmount(option.getAttribute('data-old-price')),
            articles: parseInt(option.getAttribute('data-articles'), 10) || 1
          };
        });
    }

    function updateOptionPrices() {
      options.forEach(function(option) {
        var price = parseAmount(option.getAttribute('data-price'));
        var oldPrice = parseAmount(option.getAttribute('data-old-price'));
        var currentPriceNode = option.querySelector('[data-option-current-price]');
        var oldPriceNode = option.querySelector('[data-option-old-price]');
        var checkbox = option.querySelector('.cdcconf__checkbox');

        if (currentPriceNode) {
          currentPriceNode.textContent = '+ ' + formatMoney(price);
        }

        if (oldPriceNode && oldPrice > price) {
          oldPriceNode.textContent = '+ ' + formatMoney(oldPrice);
          oldPriceNode.style.display = '';
        } else if (oldPriceNode) {
          oldPriceNode.textContent = '';
          oldPriceNode.style.display = 'none';
        }

        if (checkbox && checkbox.checked) {
          option.classList.add('is-selected');
        } else {
          option.classList.remove('is-selected');
        }
      });
    }

    function buildBody(items, total, oldTotal, articleCount) {
      var email = emailInput ? emailInput.value.trim() : '';
      var phone = phoneInput ? phoneInput.value.trim() : '';
      var lines = [];

      lines.push('Configuración Casas da Costa');
      lines.push('');
      lines.push('Email del cliente: ' + email);
      lines.push('Teléfono del cliente: ' + phone);
      lines.push('');
      lines.push('Modelo / base: ' + settings.baseTitle);
      lines.push('Precio base: ' + formatMoney(parseAmount(settings.basePrice)));

      if (parseAmount(settings.baseOldPrice) > parseAmount(settings.basePrice)) {
        lines.push('Precio base anterior: ' + formatMoney(parseAmount(settings.baseOldPrice)));
      }

      lines.push('');
      lines.push('Extras seleccionados:');

      if (items.length) {
        items.forEach(function(item) {
          var line = '- ' + item.title + ': ' + formatMoney(item.price);

          if (item.oldPrice > item.price) {
            line += ' (antes ' + formatMoney(item.oldPrice) + ')';
          }

          if (item.description) {
            line += ' | ' + item.description;
          }

          lines.push(line);
        });
      } else {
        lines.push('- Sin extras seleccionados');
      }

      lines.push('');
      lines.push('Artículos seleccionados: ' + articleCount);
      lines.push('Precio total estimado: ' + formatMoney(total));

      if (oldTotal > total) {
        lines.push('Precio anterior estimado: ' + formatMoney(oldTotal));
      }

      lines.push('');
      lines.push('Mensaje generado desde el configurador de la web.');

      return lines.join('\n');
    }

    function renderSummary() {
      updateOptionPrices();

      var items = getSelectedItems();
      var basePrice = parseAmount(settings.basePrice);
      var baseOldPrice = parseAmount(settings.baseOldPrice);
      var baseArticles = parseInt(settings.baseArticles, 10) || 0;

      var total = basePrice;
      var oldTotal = baseOldPrice > basePrice ? baseOldPrice : basePrice;
      var articleCount = baseArticles;

      items.forEach(function(item) {
        total += item.price;
        oldTotal += item.oldPrice > item.price ? item.oldPrice : item.price;
        articleCount += item.articles;
      });

      if (summaryTotal) {
        summaryTotal.innerHTML = formatTotalMoneyHtml(total);
      }

      if (summaryOldPrice) {
        if (oldTotal > total) {
          summaryOldPrice.textContent = formatMoney(oldTotal);
          summaryOldPrice.style.display = '';
        } else {
          summaryOldPrice.textContent = '';
          summaryOldPrice.style.display = 'none';
        }
      }

      if (summaryCount) {
        if (articleCount === 1) {
          summaryCount.textContent = '1 artículo seleccionado';
        } else {
          summaryCount.textContent = articleCount + ' ' + settings.selectedText;
        }
      }

      if (summaryList) {
        summaryList.innerHTML = '';

        var baseLi = document.createElement('li');
        baseLi.className = 'cdcconf__summary-item cdcconf__summary-item--base';

        var baseLeft = document.createElement('span');
        baseLeft.className = 'cdcconf__summary-item-title';
        baseLeft.textContent = '+ ' + settings.baseTitle;

        var baseRight = document.createElement('span');
        baseRight.className = 'cdcconf__summary-item-price';

        var baseCurrent = document.createElement('span');
        baseCurrent.textContent = formatMoney(basePrice);
        baseRight.appendChild(baseCurrent);

        baseLi.appendChild(baseLeft);
        baseLi.appendChild(baseRight);
        summaryList.appendChild(baseLi);

        if (items.length) {
          items.forEach(function(item) {
            var li = document.createElement('li');
            li.className = 'cdcconf__summary-item';

            var left = document.createElement('span');
            left.className = 'cdcconf__summary-item-title';
            left.textContent = '+ ' + item.title;

            var right = document.createElement('span');
            right.className = 'cdcconf__summary-item-price';

            var current = document.createElement('span');
            current.textContent = formatMoney(item.price);
            right.appendChild(current);

            li.appendChild(left);
            li.appendChild(right);
            summaryList.appendChild(li);
          });
        } else {
          var empty = document.createElement('li');
          empty.className = 'cdcconf__summary-empty';
          empty.textContent = settings.emptyText;
          summaryList.appendChild(empty);
        }
      }

      if (configBody) {
        configBody.value = buildBody(items, total, oldTotal, articleCount);
      }

      return {
        items: items,
        total: total,
        oldTotal: oldTotal,
        articleCount: articleCount
      };
    }

    function validateContact() {
      var email = emailInput ? emailInput.value.trim() : '';
      var phone = phoneInput ? phoneInput.value.trim() : '';

      var validEmail = email ? isValidEmail(email) : false;
      var validPhone = phone ? isValidPhone(phone) : false;
      var validContact = validEmail || validPhone;

      if (!validContact) {
        if (emailInput) {
          emailInput.classList.add('is-error');
        }

        if (phoneInput) {
          phoneInput.classList.add('is-error');
        }

        if (emailError) {
          emailError.textContent = settings.contactRequiredMessage;
        }

        if (emailInput) {
          emailInput.focus();
        } else if (phoneInput) {
          phoneInput.focus();
        }

        return false;
      }

      if (emailInput) {
        if (!email || validEmail || validPhone) {
          emailInput.classList.remove('is-error');
        }
      }

      if (phoneInput) {
        if (!phone || validPhone || validEmail) {
          phoneInput.classList.remove('is-error');
        }
      }

      if (emailError) {
        emailError.textContent = '';
      }

      return true;
    }

    function renderPrintArea() {
      var state = renderSummary();
      var email = emailInput ? emailInput.value.trim() : '';
      var phone = phoneInput ? phoneInput.value.trim() : '';
      var title = settings.printTitle || 'Configuración Casas da Costa';

      var html = '';
      html += '<div class="cdcconf-print">';
      html += '<h1>' + escapeHtml(title) + '</h1>';
      html += '<p><strong>Email:</strong> ' + escapeHtml(email) + '</p>';
      html += '<p><strong>Teléfono:</strong> ' + escapeHtml(phone) + '</p>';
      html += '<p><strong>Modelo / base:</strong> ' + escapeHtml(settings.baseTitle) + '</p>';
      html += '<hr>';
      html += '<h2>Extras seleccionados</h2>';

      if (state.items.length) {
        html += '<ul>';

        state.items.forEach(function(item) {
          html += '<li>';
          html += '<strong>' + escapeHtml(item.title) + '</strong> — ' + escapeHtml(formatMoney(item.price));

          if (item.description) {
            html += '<br><span>' + escapeHtml(item.description) + '</span>';
          }

          html += '</li>';
        });

        html += '</ul>';
      } else {
        html += '<p>' + escapeHtml(settings.emptyText) + '</p>';
      }

      html += '<hr>';
      html += '<p><strong>Artículos seleccionados:</strong> ' + escapeHtml(state.articleCount) + '</p>';

      if (state.oldTotal > state.total) {
        html += '<p><strong>Precio anterior estimado:</strong> <s>' + escapeHtml(formatMoney(state.oldTotal)) + '</s></p>';
      }

      html += '<p class="cdcconf-print__total"><strong>Precio total estimado:</strong> ' + escapeHtml(formatMoney(state.total)) + '</p>';
      html += '<p class="cdcconf-print__note">Documento generado desde el configurador de Casas da Costa.</p>';
      html += '</div>';

      if (printArea) {
        printArea.innerHTML = html;
      }
    }

   function openPrint() {
  renderSummary();

  if (!validateContact()) return;

  renderPrintArea();

  if (!printArea || !printArea.innerHTML.trim()) return;

  var iframe = document.createElement('iframe');

  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.opacity = '0';

  document.body.appendChild(iframe);

  var printDocument = iframe.contentWindow.document;

  printDocument.open();
  printDocument.write(`
    <!doctype html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>${escapeHtml(settings.printTitle || 'Configuración Casas da Costa')}</title>
        <style>
          @page {
            size: A4;
            margin: 12mm;
          }

          * {
            box-sizing: border-box;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            background: #ffffff;
            color: #071126;
            font-family: Arial, sans-serif;
          }

          .cdcconf-print {
            width: 100%;
            max-width: 760px;
            margin: 0 auto;
            color: #071126;
          }

          .cdcconf-print h1 {
            margin: 0 0 14px;
            font-size: 24px;
            line-height: 1.15;
          }

          .cdcconf-print h2 {
            margin: 16px 0 10px;
            font-size: 17px;
            line-height: 1.2;
          }

          .cdcconf-print p,
          .cdcconf-print li {
            font-size: 12px;
            line-height: 1.4;
          }

          .cdcconf-print p {
            margin: 0 0 7px;
          }

          .cdcconf-print ul {
            margin: 0;
            padding-left: 18px;
          }

          .cdcconf-print li {
            margin-bottom: 7px;
          }

          .cdcconf-print hr {
            margin: 14px 0;
            border: 0;
            border-top: 1px solid #d9dee7;
          }

          .cdcconf-print__total {
            margin-top: 10px !important;
            font-size: 17px !important;
            font-weight: 700;
          }

          .cdcconf-print__note {
            margin-top: 16px;
            color: #5d6b80;
            font-size: 11px !important;
          }
        </style>
      </head>
      <body>
        ${printArea.innerHTML}
      </body>
    </html>
  `);
  printDocument.close();

  setTimeout(function() {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    setTimeout(function() {
      document.body.removeChild(iframe);
    }, 1000);
  }, 250);
}

    function initOptions() {
      options.forEach(function(option) {
        var checkbox = option.querySelector('.cdcconf__checkbox');

        if (checkbox) {
          checkbox.addEventListener('change', renderSummary);
        }
      });
    }

    function initContactFields() {
      if (emailInput) {
        emailInput.addEventListener('input', function() {
          renderSummary();

          if (emailInput.classList.contains('is-error')) {
            validateContact();
          }
        });
      }

      if (phoneInput) {
        phoneInput.addEventListener('input', function() {
          renderSummary();

          if (phoneInput.classList.contains('is-error')) {
            validateContact();
          }
        });
      }
    }

    function initForm() {
      if (!form) return;

      form.addEventListener('submit', function(event) {
        renderSummary();

        if (!validateContact()) {
          event.preventDefault();
        }
      });
    }

    function initPrintButtons() {
      if (printButton) {
        printButton.addEventListener('click', function() {
          openPrint();
        });
      }

      if (pdfButton) {
        pdfButton.addEventListener('click', function() {
          openPrint();
        });
      }
    }

    function initModals() {
      var modalTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-open-modal]'));
      var modals = Array.prototype.slice.call(root.querySelectorAll('.cdcconf-modal'));
      var activeModal = null;

      function openModal(id) {
        if (!id) return;

        var modal = document.getElementById(id);
        if (!modal || !root.contains(modal)) return;

        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');

        document.documentElement.classList.add('cdcconf-modal-open');
        document.body.classList.add('cdcconf-modal-open');

        activeModal = modal;
      }

      function closeModal(modal) {
        if (!modal) return;

        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');

        document.documentElement.classList.remove('cdcconf-modal-open');
        document.body.classList.remove('cdcconf-modal-open');

        activeModal = null;
      }

      function closeAllModals() {
        modals.forEach(function(modal) {
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
        });

        document.documentElement.classList.remove('cdcconf-modal-open');
        document.body.classList.remove('cdcconf-modal-open');

        activeModal = null;
      }

      modalTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();

          openModal(trigger.getAttribute('data-open-modal'));
        });
      });

      modals.forEach(function(modal) {
        var dialog = modal.querySelector('.cdcconf-modal__dialog');
        var closeButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-close-modal]'));

        closeButtons.forEach(function(button) {
          button.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            closeModal(modal);
          });
        });

        modal.addEventListener('click', function(event) {
          var clickedClose = event.target.closest && event.target.closest('[data-close-modal]');
          var clickedOverlay = event.target.classList && event.target.classList.contains('cdcconf-modal__overlay');
          var clickedOutsideDialog = dialog && !dialog.contains(event.target);

          if (clickedClose || clickedOverlay || clickedOutsideDialog) {
            closeModal(modal);
          }
        });

        if (dialog) {
          dialog.addEventListener('click', function(event) {
            event.stopPropagation();
          });
        }

        var tabs = Array.prototype.slice.call(modal.querySelectorAll('[data-tab-trigger]'));
        var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-tab-panel]'));

        tabs.forEach(function(tab) {
          tab.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            var target = tab.getAttribute('data-tab-trigger');

            tabs.forEach(function(otherTab) {
              otherTab.classList.remove('is-active');
            });

            panels.forEach(function(panel) {
              panel.classList.remove('is-active');
            });

            tab.classList.add('is-active');

            var activePanel = modal.querySelector('[data-tab-panel="' + target + '"]');

            if (activePanel) {
              activePanel.classList.add('is-active');
            }
          });
        });
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && activeModal) {
          closeAllModals();
        }
      });
    }

    initOptions();
    initContactFields();
    initForm();
    initPrintButtons();
    initModals();
    renderSummary();
  }

  function initAllCasasDaCostaConfigurators() {
    var roots = document.querySelectorAll('[data-cdc-configurator]');

    roots.forEach(function(root) {
      initCasasDaCostaConfigurator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCasasDaCostaConfigurators);
  } else {
    initAllCasasDaCostaConfigurators();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('[data-cdc-configurator]');

    if (root) {
      initCasasDaCostaConfigurator(root);
    }
  });

  window.addEventListener('afterprint', function() {
    document.body.classList.remove('cdcconf-printing');
  });
})();